import axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";
import qs from "qs";

import { env } from "@/configs/env";

import { REQUEST_TIMEOUT } from "./constants";
import { setupInterceptors } from "./interceptors";

export interface CreateRequestInstanceOptions {
  baseURL?: string;
  timeout?: number;
  config?: AxiosRequestConfig;
}

/**
 * Sozlanadigan bazaviy manzil bilan axios nusxasini yaratadigan fabrika.
 * Har bir nusxaga interceptorlar o'zi o'rnatiladi.
 *
 * @param options - so'rov nusxasi uchun sozlamalar
 * @returns interceptorlari o'rnatilgan axios nusxasi
 *
 * @example
 * // Standart bazaviy manzil bilan nusxa
 * const request = createRequestInstance({
 *   baseURL: import.meta.env.VITE_API_BASE_URL
 * });
 */
export function createRequestInstance(options: CreateRequestInstanceOptions = {}): AxiosInstance {
  const { baseURL = env.API_BASE_URL, timeout = REQUEST_TIMEOUT, config = {} } = options;

  const instance = axios.create({
    baseURL,
    timeout,
    // Refresh token endi `lu_rt` HttpOnly cookie'sida va JavaScript uni
    // KO'RMAYDI. Brauzer uni faqat shu bayroq bilan biriktiradi. Backend
    // tomonda CORS `credentials: true` bilan ochilgan.
    withCredentials: true,
    paramsSerializer: params => qs.stringify(params, { indices: false }),
    ...config,
  });

  setupInterceptors(instance);

  return instance;
}
